<div class="input-group action">
    <div class="input-group-btn btn-in-table">
        <button (click)="onClick('addOffice')" class="btn btn-white btn-xs">
            Add Office
        </button>

        <button class="btn btn-white btn-xs action__btn" (click)="toggle()">
            <span class="caret"></span>
        </button>
        <ul [class.active]="isShow" class="action__dropdown-menu dropdown-menu pull-right">
            <li (click)="onClick('removeCompany')">
                <a>Delete This Company</a>
            </li>
        </ul>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/company-view/action-button/action-button.component.html